import { Div, Image } from "@tblabs/truffle";
import { Product } from "../../Models/Product/Product";


export class SearchResultItem extends Div
{
    constructor(product: Product)
    {
        super("");

        this.Append(
            new Image(product.Images.First()?.MiniUrl?.value ?? "").Height(32).Width(48).ObjectFit("cover").DisplayInlineBlock().MarginRight(8).BorderRadius(4),
            product.Title.value);
    }
}
